<template>
    <path fill-rule="evenodd" d="M17.413 21.814c-3.591-.005-5.309-1.921-5.305-4.338v-.732l4.024.006v.318c-.001.79.408 1.331 1.19 1.332.72.001 1.075-.332 1.075-.894.003-1.597-6.151-1.338-6.145-5.811.003-2.413 1.533-4.514 5.338-4.509 3.42.005 5.116 1.925 5.112 4.336v.786l-4.023-.006.001-.45c0-.649-.334-1.297-1.094-1.298-.606 0-.956.335-.957.876-.002 1.766 6.148 1.321 6.142 5.794-.003 2.414-1.607 4.595-5.358 4.59zM6.232 15.398c.543-.177 1.2-.348 1.201-.819l.005-3.155 3.986.006-.004 2.668c-.002 1.319-.445 2.06-1.42 2.33 1.02.408 1.416 1.136 1.413 2.693l-.003 2.283-3.986-.032.004-2.984c0-.595-.657-.668-1.2-.853l.004-2.137zm1.232-7.939h3.96l-.004 3.145-3.96-.006.004-3.139zM14.5 0C6.492 0 0 6.492 0 14.5S6.492 29 14.5 29 29 22.508 29 14.5 22.508 0 14.5 0z"/>
</template>

<script>
export default {
    name: 'isLogoIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 29 29');
    }
}
</script>
